import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notAvailable',
  standalone: true,
})
export class NotAvailablePipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) {
      return 'Not Available';
    }

    return value;
  }
}
